import React, { useEffect } from 'react';

import { Button, Header } from '@/components';

import { useAppDispatch } from '@redux/store';
import { resetCartItems } from '@redux/cart/slice';
import { cartSelector } from '@redux/cart/selectors';
import { useSelector } from 'react-redux';
import { loggerSendingData } from '@/redux/actions/logger.action';

import techRequest from '@/assets/icons/techRequest.svg';
import arrowIcon from "@/assets/icons/arrowCalendarRightGreen.svg"
import styles from './PaymentSuccess.module.scss';
import paymentSuccessImg from '@/assets/img/paymentSuccessImg.svg';
import addressMark from '@/assets/icons/addressMark.svg';
import historyIcon from '@/assets/icons/historyIcon.svg';

import {
  removeCartItemsFromStorage,
  removeRentDateFromStorage,
  removeTotalPriceFromStorage,
} from '@/utils';
import { useLocation } from 'react-router-dom';

export const PaymentSuccess: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { totalCartItems } = useSelector(cartSelector);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    removeCartItemsFromStorage();
    removeRentDateFromStorage();
    removeTotalPriceFromStorage();
    dispatch(resetCartItems());
  }, []);

  useEffect(() => {
    loggerSendingData({
      type: 'SuccessPaymentScreenLocalData',
      data: {
        courtRent: totalCartItems.seats || {},
        racketRent: totalCartItems.rackets || {},
      },
    }).catch((error) => {
      console.warn('Ошибка логирования SuccessPaymentScreen:', error);
    });
  }, [totalCartItems]);

  return (
    <>
      <Header title={""} />
      <main>
        <section className={styles.wrapper}>
          <div className={styles.paymentSuccess}>
            <img src={paymentSuccessImg} alt="payment success" />

            <div className={styles.textWrapper}>
              <p className={styles.errorPaymentTitle}>
                Оплата прошла успешно
              </p>
              <p className={styles.emptyBasketCartDescription}>
                Информацию о приобретенных услугах Вы всегда сможете найти в разделе “Профиль”
              </p>
            </div>

            <div className={styles.buttonsWrapper}>
              <Button newStyles={styles.button} to="/profile/history">
                <div className={styles.buttonContent}>
                  <img src={historyIcon} alt="techRequest" />
                  <span>
                    История покупок
                  </span>
                </div>
                <img src={arrowIcon} alt='arrow icon' />
              </Button>
              <Button newStyles={styles.button} to="/about/court-layout">
                <div className={styles.buttonContent}>
                  <img src={addressMark} alt="techRequest" />
                  <span>
                    Схема проезда
                  </span>
                </div>
                <img src={arrowIcon} alt='arrow icon' />
              </Button>
              <Button newStyles={styles.button} to="/school">
                <div className={styles.buttonContent}>
                  <img src={techRequest} alt="techRequest" />
                  <span>
                    Обратная связь
                  </span>
                </div>
                <img src={arrowIcon} alt='arrow icon' />
              </Button>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
